import { render, staticRenderFns } from "./AppraisalFacetScoresDrillDown2.vue?vue&type=template&id=5c9e4e7c&"
import script from "./AppraisalFacetScoresDrillDown2.vue?vue&type=script&lang=ts&"
export * from "./AppraisalFacetScoresDrillDown2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports